import {
    ADDITIONAL_CMS_SITE_STRUCTURE_CONFIRMATION,
    TRACKING_OFORM_FORM_STATUS_START,
    TRACKING_OFORM_FORM_STATUS_SUCCESS,
    TRACKING_OFORM_FORM_STEP_NAME_CONFIRMATION,
    TRACKING_OFORM_FORM_STEP_NAME_PERSONAL_DETAILS,
    TRACKING_OFORM_FORM_STEP_ONE,
    TRACKING_OFORM_FORM_STEP_TWO,
    TRACKING_OFORM_NAME,
    TRACKING_OFORM_TYPE,
    TRACKING_PAGE_TYPE,
} from '../constant';
import {
    TRACKING_PLATFORM_TYPE_RESPONSIVE,
    TRACKING_SITE_AREA_MOBILITY,
    TrackType,
    TrackingLoginStatus,
    trackIt,
} from '@vfde-sails/tracking';
import { IOForm } from '../interface';

const defaultOForm: IOForm = {
    name: TRACKING_OFORM_NAME,
    type: TRACKING_OFORM_TYPE,
    formStep: TRACKING_OFORM_FORM_STEP_ONE,
    formStepName: TRACKING_OFORM_FORM_STEP_NAME_PERSONAL_DETAILS,
    formStatus: TRACKING_OFORM_FORM_STATUS_START,
};

/**
 * initTracking
 */
export const trackPageView = (siteStructure: string[], oForm = defaultOForm) => {
    const trackingPayload = {
        tealiumUseDCF: true,
        pageType: TRACKING_PAGE_TYPE,
        loginStatus: TrackingLoginStatus.NotLoggedIn,
        siteArea: TRACKING_SITE_AREA_MOBILITY,
        platformType: TRACKING_PLATFORM_TYPE_RESPONSIVE,
        siteStructure,
        oForm,
    };

    trackIt(TrackType.PageView, trackingPayload);
};

/**
 * track successful form submit
 *
 */
export const successTracking = () => {
    const oForm: IOForm = {
        name: TRACKING_OFORM_NAME,
        type: TRACKING_OFORM_TYPE,
        formStep: TRACKING_OFORM_FORM_STEP_TWO,
        formStepName: TRACKING_OFORM_FORM_STEP_NAME_CONFIRMATION,
        formStatus: TRACKING_OFORM_FORM_STATUS_SUCCESS,
    };

    trackPageView(ADDITIONAL_CMS_SITE_STRUCTURE_CONFIRMATION, oForm);
};
